document.addEventListener("DOMContentLoaded", function () {

  const tabs = document.querySelectorAll(".kana-tab");
  const kanaMode = document.querySelector(".kana-mode-kana");
  const azMode = document.querySelector(".kana-mode-az");

  const kanaNav = document.querySelector(".kana-nav-kana");
  const azNav = document.querySelector(".kana-nav-az");

  tabs.forEach(tab => {
    tab.addEventListener("click", function() {

      tabs.forEach(t => t.classList.remove("is-active"));
      this.classList.add("is-active");

      if (this.dataset.tab === "kana") {
        kanaMode.style.display = "block";
        azMode.style.display = "none";
        kanaNav.style.display = "flex";
        azNav.style.display = "none";
      } else {
        kanaMode.style.display = "none";
        azMode.style.display = "block";
        kanaNav.style.display = "none";
        azNav.style.display = "flex";
      }

    });
  });

  /* スムーススクロール */
  const links = document.querySelectorAll(".kana-nav a");
  links.forEach(link => {
    link.addEventListener("click", function(e){
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (!target) return;

      const offset = 80;
      window.scrollTo({
        top: target.offsetTop - offset,
        behavior: "smooth"
      });
    });
  });

});

const pageTop = document.getElementById("pageTop");

if (pageTop) {

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      pageTop.classList.add("is-visible");
    } else {
      pageTop.classList.remove("is-visible");
    }
  });

  pageTop.addEventListener("click", function () {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });

}